import { useNavigate, useSearchParams, generatePath } from 'react-router';
import { useTranslation } from '@packlink/translation-provider';
import { Button, ButtonVariant, Typography } from '@shipengine/giger';
import { APP_ROUTE } from '@router/routes';
import { AmplitudeEvents } from '@constants/amplitude';
import { useAmplitude } from '@common/hooks';
import { Box } from '../../components/Box/Box';
import {
    getButtonsStyles,
    getImageStyles,
    getOnboardingCompletedStyles,
    getTitleStyles,
} from './OnboardingCompletedStyles';

export function OnboardingCompleted(): JSX.Element {
    const { sendAmplitudeClickEvent } = useAmplitude();
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const {
        cdn: { url: cdnUrl },
    } = config;

    const storeToConnect = searchParams.get('connect') ?? undefined;

    const title = storeToConnect
        ? t('onboarding.completed.connect-store-title')
        : t('onboarding.completed.no-store-title');
    const subtitle = storeToConnect
        ? t('onboarding.completed.connect-store-subtitle')
        : t('onboarding.completed.no-store-subtitle');
    const mainButton = storeToConnect
        ? t('onboarding.completed.connect-store')
        : t('onboarding.completed.start-shipping');

    const goToDashboard = () => {
        sendAmplitudeClickEvent(AmplitudeEvents.ONBOARDING_COMPLETED_DASHBOARD, {
            store: storeToConnect ? 'yes' : 'no',
        });

        navigate(APP_ROUTE.SHIPMENTS.INBOX_ALL);
    };

    const onMainAction = () => {
        const path = storeToConnect
            ? generatePath(APP_ROUTE.SETTINGS.INTEGRATIONS_ALIAS, { alias: storeToConnect })
            : generatePath(APP_ROUTE.CHECKOUT.STEP_INFO);

        sendAmplitudeClickEvent(
            storeToConnect
                ? AmplitudeEvents.ONBOARDING_COMPLETED_CONNECT
                : AmplitudeEvents.ONBOARDING_COMPLETED_START_SHIPPING,
            {
                store: storeToConnect,
            },
        );

        navigate(path, { state: { isNew: true } });
    };

    return (
        <Box css={getOnboardingCompletedStyles}>
            <img css={getImageStyles} src={`${cdnUrl}/subscriptions/images/rocket.svg`} alt="" aria-hidden={true} />
            <div>
                <Typography css={getTitleStyles} variant="heading4" component="h4">
                    {title}
                </Typography>

                <Typography variant="body2" component="span">
                    {subtitle}
                </Typography>

                <div css={getButtonsStyles}>
                    <Button onClick={goToDashboard} variant={ButtonVariant.TEXT}>
                        {t('onboarding.completed.to-dashboard')}
                    </Button>
                    <Button onClick={onMainAction} variant={ButtonVariant.FILLED}>
                        {mainButton}
                    </Button>
                </div>
            </div>
        </Box>
    );
}
